import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { actions as recipeActions } from 'src/state/recipe';
import RecipeIndex from './presenter';
import Types from 'Types';
import { selectRecipes } from 'src/state/recipe/selectors';
import { withRouter } from 'react-router-dom';

interface State {

}

const mapStateToProps = (state: Types.RootState, ownProps: State) => ({
  recipes: selectRecipes(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Types.RootAction>) => bindActionCreators({
  fetchRecipes: recipeActions.fetchRecipes.request
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RecipeIndex));